import { useContext, useEffect, useState } from "react";
import { ProjectContext } from "../../../context/ProjectContext";
import Pagination from "./Pagination";
import { EllipsisVertical , Pin , PinOff } from "lucide-react";
import DeleteToast from "./DeleteToast";
import {toast} from 'react-toastify'
import MultiSelect from 'multiselect-react-dropdown';
const AllProject = () => {  
  const { paginationProjects , addProject ,isLoading, getProject ,updateProject,deleteProject ,getAllStaff , staff ,pinProject} = useContext(ProjectContext);
  const [projectDetails, setProjectDetails] = useState({
    projectName:"",
    description:"",
    isPinned:false,
    cost:0,
    startDate: "",
    endDate:"",
    deadLine:"",
    teamMembers:[],
    status:"",
    category:"",
    filterClass:''
  });
  const [formError,setError] = useState({});

  const [openUtilityMenuId,setUtilityMenu] = useState(null);
  const [editingId,setEditingId] = useState(null); // for edit mode
  const CATEGORY_OPTIONS = [
    { category: 'Web Development', filterClass: 'web-dev' },
    { category: 'App Development', filterClass: 'app-dev' },
    { category: 'Software Development', filterClass: 'software-dev' },
    { category: 'Designing', filterClass: 'design' },
  ];

  const state = {
    options:[{name:"apple"},{name:"bannana"},{name:"cherry"}]
  }

  const handleAddProjectModal = () => {
    setEditingId(null); //we are not editing 
    // make sure all inputs are clear 
    setError({});
    setProjectDetails({
      projectName:"",
      description:"",
      isPinned:false,
      cost:0,
      startDate: "",
      endDate:"",
      deadLine:"",
      teamMembers:[],
      status:"",
      category:"",
      filterClass:''
    })
    document.getElementById("my_modal_3").showModal();
  };


  //fetch all Project's

  useEffect(()=>{
    const fetchProject = async() =>{
      await getProject();
    }
    const fetchStaff = async() =>{
      await getAllStaff();
    }

    fetchProject();
    fetchStaff();
  },[])


  //pagination related 
  
  const handleProjectDetailChange = (e) =>{
    const {name , value} = e.target;
    // console.log('element name '+name+' value '+value); 
    setProjectDetails((prevState) => (
      { ...prevState,[name]:value }
    ))
  }
  const handleCategoryChange = (e) =>{
    const selectedCategory = e.target.value;
    // console.log(selectedCategory);
    //find full object of that category
  
    const selectedOption = CATEGORY_OPTIONS.find((c) => c.category == selectedCategory);

    setProjectDetails((prevState) => (
      {...prevState,category: selectedOption.category,filterClass: selectedOption.filterClass}
    ))    
  }

  const handleCostChange = (e) =>{
    const currentCost = e.target.value;

    setProjectDetails((prevState)=> (
      {...prevState,cost:currentCost}
    ))
    if(currentCost <= 0 || currentCost == ''){
      setError({cost:"*Cost must be greater than 0"});
    }else{    
      setError({});
    }
  }
  
  //---the teamGrouping drop down logic---
  const onSelect = (selectedList,selectedStaff) =>{
      setProjectDetails((prevState) => (
        {...prevState,teamMembers:selectedList}
      ))

      //optional we can keep or remove depend how we want show
      // if(selectedList.length == 0){
      //   setError({members:"*Select Team Members"})
      // }else{
      //   setError({}); 
      // }
  }

  const onRemove = (selectedList,removedItem)=>{
    // console.log('selected Item',removedItem);
    // console.log('item removed from list',selectedList);
    setProjectDetails((prevState) => (
      {...prevState,teamMembers:selectedList}
    ))
  }
  // console.log('project details',projectDetails);

  const handleProjectDetailSubmit = async(e) =>{
    e.preventDefault();
    if(projectDetails.cost == 0){
        const newError = {};
        newError.cost = "*Invalid Amount"
        setError(newError);
        return;
    }
    if(projectDetails.teamMembers.length == 0){
      setError({members:"*Select Team Members"})
      return;
    }
    if(editingId){
        await updateProject(editingId,projectDetails);
        document.getElementById('my_modal_3').close();
    }else{
        await addProject(projectDetails);
        document.getElementById('my_modal_3').close();
        //clear inputs
        setError({});
        setProjectDetails({
        projectName:"",
        description:"",
        isPinned:false,
        cost:0,
        startDate: "",
        endDate:"",
        deadLine:"",
        teamMembers:[],
        status:"",
        category:"",
        filterClass:''
      })
    }
}

  const showUtilityModal = (projectId) =>{
    setUtilityMenu((prevId) => prevId == projectId ? null : projectId);
  }

  const handleEditClick = (project) =>{
    setUtilityMenu(null);
    setError({});
    setEditingId(project._id);
    setProjectDetails({
      projectName: project.projectName,
      description: project.description,
      cost: project.cost,
      startDate: new Date(project.startDate).toISOString().split('T')[0],
      endDate: new Date(project.endDate).toISOString().split('T')[0],
      deadLine: new Date(project.deadLine).toISOString().split('T')[0],
      teamMembers:project.teamMembers,
      category: project.category,
      status: project.status,
    })

    document.getElementById('my_modal_3').showModal();
  }

  const handleDeleteClick = (projectId) =>{
    setUtilityMenu(null);//hide menu
    const performDelete = async() =>{
      await deleteProject(projectId);
    }
    toast.warn(<DeleteToast       
    onConfirm={performDelete}/>,
    {
      autoClose:false,
      closeButton:false,
      closeOnClick:false,
      draggable:false,
      position:"top-right"
    })    
  }

  const handlePin = async(project) =>{
    showUtilityModal(null);
    await pinProject(project._id,!project.isPinned);
  }
  return (
    <>
      <div className="min-h-screen p-4 bg-gray-50">
        <h1 className="text-center font-bold text-2xl text-gray-700">Manage Project</h1>
        <div className="flex justify-end mt-8">
          <button
            onClick={handleAddProjectModal}
            className="bg-[#161617] p-2 rounded-md hover:bg-gray-800 text-white"
          >
            Add Project
          </button>
        </div>
        
        {/* --- Card Grid --- */}
        { (isLoading) ? 
          (<div className="text-center text-gray-600 mt-10">
            Loading...
           </div>) 
          :(paginationProjects.length == 0) ? (
          <div className="text-center text-gray-500 mt-10">
            <h1>No Project Found</h1>
          </div>) 
          :(<div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-h-[500px] overflow-y-auto">
          {/* Card */}
          {paginationProjects.map((project,index)=> 
          <div key={project._id} className="relative bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer hover:-translate-y-1 border border-gray-200 flex flex-col justify-between">
            <div>
              {/* ... Card content ... */}
              <div className="flex justify-between items-start mb-2">
                <h2 className="font-bold text-xl text-gray-800">
                  {project.projectName}
                </h2>
                <span className="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-1 rounded-full">
                  {project.status}
                </span>
              </div>
              <div className="text-sm font-medium text-gray-500 mb-3">
                {project.category}
              </div>
              <p className="text-gray-600 text-sm mb-4">
                {project.description}
              </p>
            </div>
            <div>
              {/* Dates Section */}
              <div className="border-t border-gray-100 pt-4 mb-4">
                <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
                  <div className="text-gray-500">Start Date</div>
                  <div className="text-gray-700 font-medium">{new Date(project.startDate).toLocaleDateString('en-GB',{
                    day:"numeric",
                    month:"numeric",
                    year:"numeric"
                  })}
                  </div>
                  <div className="text-gray-500">End Date</div>
                  <div className="text-gray-700 font-medium">{new Date(project.endDate).toLocaleDateString('en-GB',{
                    day:"numeric",
                    month:"numeric",
                    year:"numeric",
                  })}
                  </div>
                  <div className="text-red-500">Deadline</div>
                  <div className="text-red-500 font-medium">{new Date(project.deadLine).toLocaleDateString('en-GB',{
                    day:"numeric",
                    month:"numeric",
                    year:"numeric"
                  })}
                  </div>
                  <div className="text-green-600 font-semibold">
                    cost
                  </div>
                 <div className="text-green-500 font-semibold">
  ₹{project?.cost ? project.cost.toLocaleString() : "0"}
</div>

                </div>
              </div>
              {/* Team Members Section */}
              <div className="border-t border-gray-100 pt-4">
                <h3 className="text-xs font-semibold text-gray-500 uppercase mb-2">Team</h3>
                <div className="flex items-center space-x-2">
                  {project?.teamMembers.map((member) => (                     
                  <span key={member._id} className="bg-gray-200 text-gray-700 px-3 py-1 rounded-full text-sm font-medium">
                    {member.name}
                  </span>
                  )) 
                  }
                </div>
              </div>
            </div>
            {/* small 3 dot icon and menu section  */}
            <EllipsisVertical onClick={() => showUtilityModal(project._id)}  className="absolute bottom-2 right-1"/>
              {openUtilityMenuId == project._id && <div className="absolute bottom-9 right-4 text-gray-800 text-center w-fit rounded-md bg-gray-200 shadow-md">
                <p onClick={() => handleEditClick(project)} className=" border-b  p-2 rounded-t-md hover:bg-gray-400">Edit</p>
                <p onClick={() => handleDeleteClick(project._id)} className=" border-b p-2 hover:bg-gray-400">Delete</p>
                <p onClick={() => handlePin(project)} className="border-b p-2 rounded-b-md hover:bg-gray-400">{project.isPinned ? "Unpin" : "Pin"}</p>
              </div>
              }
              {/* //pinOff icon  */}
            {project?.isPinned && <PinOff className="absolute right-1 top-1 text-gray-700"/>}
          </div>)}
        </div>)}

        <Pagination />

        {/* --- Modal --- */}
        <dialog id="my_modal_3"  className="modal rounded-md w-full max-w-4xl">
          <div className="modal-box w-full bg-white">
            {/* Close button form */}
            <form method="dialog">
              <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
            </form>

            {/* --- Main Add Project Form --- */}
            <form onSubmit={handleProjectDetailSubmit} className="mt-4">
              <h1 className="text-center text-gray-700 font-bold text-xl mb-6">
                {editingId ? "Edit Project" : "Add New Project"}
              </h1>

              {/* Two-column layout */}
              <div className="flex p-8 flex-col md:flex-row md:space-x-6">
                
                {/* --- Left Column --- */}
                <div className="flex-1 flex flex-col w-full space-y-4">
                  <div>
                    <label htmlFor="projectName" className="block text-xl font-medium text-gray-700 mb-1">
                      Project Name
                    </label>
                    <input
                      type="text"
                      id="projectName"
                      name="projectName"
                      value={projectDetails.projectName}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary1 bg-white text-gray-900"
                      required
                      onChange={handleProjectDetailChange}
                    />
                  </div>
                  <div>
                    <label htmlFor="description" className="block text-xl font-medium text-gray-700 mb-1">
                      Description
                    </label>
                    <textarea
                      id="description"
                      name="description"
                      value={projectDetails.description}
                      rows="5"
                      className="w-full  max-h-[100px] p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary1 bg-white text-gray-900 min-h-[120px]"
                      required
                      onChange={handleProjectDetailChange}
                    ></textarea>
                  </div>
                  <div>
                    <label htmlFor="cost" className="block text-xl font-medium text-gray-700 mb-1">
                     Project Cost
                    </label>
                    <input 
                       type="number"
                       name="cost" 
                       value={projectDetails.cost}
                       id="cost" 
                       className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary1 bg-white text-gray-900"
                       required
                       onChange={handleCostChange}
                     />
                  </div>
                  {formError.cost && <span className="text-red-500 font font-medium">{formError.cost}</span>}
                  <div>
                    <label htmlFor="startDate" className="block text-xl font-medium text-gray-700 mb-1">
                      Start Date
                    </label>
                    <input
                      type="date"
                      id="startDate"
                      name="startDate"
                      value={projectDetails.startDate}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary1 bg-white text-gray-900"
                      required
                      onChange={handleProjectDetailChange}
                    />
                  </div>
                </div>

                {/* --- Right Column --- */}
                <div className="flex-1 flex flex-col space-y-4 mt-4 md:mt-0">
                  <div>
                    <label htmlFor="endDate" className="block text-xl font-medium text-gray-700 mb-1">
                      End Date
                    </label>
                    <input
                      type="date"
                      id="endDate"
                      name="endDate"
                      value={projectDetails.endDate}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary1 bg-white text-gray-900"
                      required
                      onChange={handleProjectDetailChange}
                    />
                  </div>
                  <div>
                    <label htmlFor="deadLine" className="block text-xl font-medium text-gray-700 mb-1">
                      Deadline
                    </label>
                    <input
                      type="date"
                      id="deadLine"
                      name="deadLine"
                      value={projectDetails.deadLine}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary1 bg-white text-gray-900"
                      required
                      onChange={handleProjectDetailChange}
                    />
                  </div>
                  <div>
                    <label htmlFor="category" className="block text-xl font-medium text-gray-700 mb-1">
                      Category
                    </label>
                    
                    <select
                      id="category"
                      name="category"
                      value={projectDetails.category}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary1 bg-white text-gray-900"
                      defaultValue=""
                      required
                      onChange={handleCategoryChange}
                    >
                    <option disabled value="">select category</option>
                    {CATEGORY_OPTIONS.map((item,index) => 
                      <option key={index} value={item.category}>
                        {item.category}
                      </option>
                     )} 
                    </select>
                 
                  </div>
                  <div>
                    <label htmlFor="status" className="block text-xl font-medium text-gray-700 mb-1">
                      Status
                    </label>
                    <select
                      id="status"
                      name="status"
                      value={projectDetails.status}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary1 bg-white text-gray-900"
                      defaultValue=""
                      required
                      onChange={handleProjectDetailChange}
                    >
                      <option value="" disabled>Select status</option>
                      <option value="upcoming">Upcoming</option>
                      <option value="ongoing">Ongoing</option>
                      <option value="completed">Completed</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="teamMember" className="block text-xl font-medium text-gray-700 mb-1">Team Members</label>
                    <MultiSelect 
                      options={staff} //its just want array somthing iterable
                      selectedValues={projectDetails.teamMembers}
                      onSelect={onSelect}
                      onRemove={onRemove}
                      showCheckbox
                      displayValue="name"
                    />
                    {formError.members && <span className="text-red-500 font-medium">{formError.members}</span>}
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-4 border-t border-gray-200 flex justify-end">
                <button
                  type="submit"
                  className="bg-[#161617] p-2 m-2 rounded-md hover:bg-gray-800 text-white font-medium px-6"
                >
                  {editingId ?  "Edit Project" : "Add Project"}
                </button>
              </div>
            </form>
          </div>
        </dialog>
      </div>
    </>
  );
};

export default AllProject;